'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeOutUp = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '-100%', 0)
  }
};
exports.default = fadeOutUp;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-out-up.js
// module id = 2131
// module chunks = 0